import { render, staticRenderFns } from "./AllProduk.vue?vue&type=template&id=77e78694&"
import script from "./AllProduk.vue?vue&type=script&lang=js&"
export * from "./AllProduk.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports